/* eslint-disable react/display-name */

import React, { useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button
} from "reactstrap"
import DatatableTables from "components/tables/DatatableTables";
import { get } from 'helpers/api_helper'
import { REPORTS_URL } from 'helpers/url_helper'
import moment from 'moment'
import "flatpickr/dist/themes/material_red.css"
import Flatpickr from "react-flatpickr"

const Timezone = (dateString) => {    
  const date = moment(dateString).toDate();
  return moment(date).format('YYYY-MM-DD');;
}

const Reports = () => {
    const queryParams = new URLSearchParams(location.search);
    const rt = queryParams.get('_q');

    const [data, setData] = useState([])
    const [filters, setFilters] = useState({
      diner_type: 'employee',
      dine_type: 'lunch',
      date: moment().format('yyyy-MM-DD'),

    })

    const fetchData = async()=>{
        setData([])
        const res = await get(`${REPORTS_URL}?_q=${rt}`);
        if(res.success){
            setData(res.body)
        }
    }

    const columns = [{
        dataField: 'id',
        text: '#',
        sort: true,
      },{
        dataField: 'token_no',
        text: 'Token #',
        sort: true,
        formatter: (cell, row) => <b className='text-denger'>{row.token_no}</b>
      },{
        dataField: 'name',
        text: 'Name',
        sort: true
      },{
        dataField: 'dinner_code',
        text: 'Dinner Code',
        sort: true
      },{
        dataField: 'meal_type',
        text: 'Meal Type',
        sort: true
      },{
        dataField: 'is_guest',
        text: 'Guest',
        sort: true        
      },{
        dataField: 'dine_date',
        text: 'Dine Date',
        formatter: (cell, row) => <b className='text-denger'>{row.dine_date}</b>
      },{
        dataField: 'dine_time',
        text: 'Dine Time',
        formatter: (cell, row) => <b className='text-denger'>{row.dine_time}</b>
    }]

    useEffect(() =>{
        fetchData();
    }, [rt])

    const capitalizeFirstLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1);

    const handleFilterSubmission = () => {
      fetchData(filters)
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Reports | Advance Dental Export Canteen Management</title>
                </MetaTags>
                <Container fluid>
                    <Row>
                      <Col>
                        <Card>
                          <CardBody>
                            <Row>
                              <Col>
                                <label>Dine Type</label>
                                <select className="form-control" defaultValue={filters?.dine_type} onChange={(e) => setFilters(prev => ({...prev, dine_type:e.target.value}))}>
                                  <option value="" >Both</option>
                                  <option value="1" >Lunch</option>
                                  <option value="2" >Dinner</option>
                                </select>
                              </Col>
                              <Col>
                                <label>Diner Type</label>
                                <select className="form-control" defaultValue={filters?.diner_type} onChange={(e) => setFilters(prev => ({...prev, diner_type:e.target.value}))}>
                                  <option value="" >All</option>
                                  <option value="1" >Employees</option>
                                  <option value="2" >Guests</option>
                                  <option value="3" >Temporary Employees</option>
                                </select>
                              </Col>
                              <Col>
                                <label>Date Wise</label>
                                <Flatpickr
                                  className="form-control d-block"
                                  placeholder="DD-MM-YYYY"
                                  options={{
                                      mode: "range",
                                      dateFormat: "d-m-Y"
                                  }}
                                  defaultValue={moment().format('DD-MM-YYYY')}
                                  onChange={
                                      (e) => {
                                          const dates = e.map(dateString => Timezone(dateString));
                                          setFilters(prev => ({...prev, date:dates}))
                                      }
                                  }
                              />
                              </Col>
                              {/* <Col>
                                <label>Company Wise</label>
                                <input name="date" className="form-control"/>
                              </Col> */}
                            </Row>
                            <br />
                            <Row>
                              <Col className="text-end">
                                <Button className="btn btn-primary" onClick={handleFilterSubmission}>Filter</Button>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                    
                    <br/>

                    {
                        Object.keys(data)?.length ? 
                        <DatatableTables
                          key={'id'}
                          title={`${capitalizeFirstLetter(rt)} Tokens Issued Report`}
                          columns={columns || []}
                          csv_filename={`${rt}_tokens_report_${moment().format('YYYY-MM-DD')}`}
                          rows={data?.dinners || []} />
                        : ''
                    }
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Reports;
